import { FinancialSectionTooltipProps } from "./types";

export const FINANCIAL_TOOLTIPS: FinancialSectionTooltipProps = {
  capEx: {
    title: "CapEx",
    text: "The upfront capital cost to set up the initiative. Paid once, at the start.",
    chip: "Input",
  },
  opexChange: {
    title: "Annual OpEx Change (±)",
    text: "How much the yearly operating costs change because of this initiative. Use a positive number for an increase, a negative number for a reduction.",
    chip: "Input",
  },
  grossSavings: {
    title: "Annual Gross Savings",
    text: "The yearly savings this initiative generates — before any change in operating costs is applied.",
    chip: "Input",
  },
  tco2eAvoided: {
    title: "Annual tCO2e Avoided",
    text: "The yearly greenhouse gas emissions avoided by this initiative. Feeds the Waterfall and MACC charts in Initiatives Modeling.",
    chip: "Input",
  },
  lifespan: {
    title: "Project Lifespan",
    text: "How many years the initiative keeps delivering benefit. ",
    chip: "Input",
  },
  discountRate: {
    title: "Discount Rate",
    text: "The yearly rate used to convert future cash into today's money. Reflects your cost of capital — typically 6–10%.",
    chip: "Input",
  },
  netAnnualBenefit: {
    title: "Net Annual Benefit",
    text: "The yearly cash benefit, after the change in operating costs is netted out.",
    formula: "Annual Gross Savings − Annual OpEx Change",
  },
  simplePayback: {
    title: "Simple Payback",
    text: "How long it takes for the yearly benefit to cover the upfront cost.",
    formula: "CapEx ÷ Net Annual Benefit",
  },
};
